import React  from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { OverlayTrigger, Tooltip} from "react-bootstrap";

const DayOffItem = (props) => {
	const dayOffInfoTooltip = (
		<Tooltip id={props.id}>
			<h5 className="event-text"> <strong>Name:</strong> <span className="event-value">{props.name}</span> </h5>
			<h5 className="event-text"> <strong>Start:</strong> <span className="event-value">{moment(props.start).format("DD-MM-YYYY")}</span> </h5>
			<h5 className="event-text"> <strong>End:</strong> <span className="event-value">{moment(props.end).format("DD-MM-YYYY")}</span> </h5>
			<h5 className="event-text"> <strong>Type:</strong> <span className="event-value">{props.type_name}</span> </h5>
			{props.country_name && <h5 className="event-text"> <strong>Country:</strong> <span className="event-value">{props.country_name}</span> </h5>}
			{props.full_name && <h5 className="event-text"> <strong>User:</strong> <span className="event-value">{props.full_name}</span> </h5>}
			{props.description && 
			<h5 className="event-text"> 
				<strong>Description: </strong> 
				<span className="event-value">{props.description.length > 200 ? ` ${props.description.substring(0, 200)} ...`: props.description}</span> 
			</h5>}		
		</Tooltip> 
	); 
	
	return (
		<OverlayTrigger  overlay={dayOffInfoTooltip} placement="top" delayShow={100} delayHide={100}>
			<span className="dayOff-item">
				<span  className="dayoff-item-name">{props.name.length > 25 ? ` ${props.name.substring(0,25)} ...`: props.name}</span>
				{props.status && <span className={`dayoff-status dayoff-status-${props.status}`}/>}
			</span> 
		</OverlayTrigger>
	);
};

DayOffItem.defaultProps = {
	country_name: PropTypes.string,
	full_name: PropTypes.string,
	description: PropTypes.string,
	status: PropTypes.string
};

DayOffItem.propTypes = {
	id: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	type_name: PropTypes.string.isRequired,
	start: PropTypes.string.isRequired,
	end: PropTypes.string.isRequired, 
	country_name: PropTypes.string,
	full_name: PropTypes.string,
	description: PropTypes.string,
	status: PropTypes.string
};

export default DayOffItem;


// WEBPACK FOOTER //
// ./src/components/partials/DayOffItem.js